import { renderDivider_unstable } from '@fluentui/react-divider';

/**
 * Renders the final JSX of the ToolbarDivider component, given the state.
 */
export const renderToolbarDivider = renderDivider_unstable;
